export default __webpack_public_path__ + "static/media/DNo.5-3.2b94ad7a.jpg";